// eslint-disable-next-line no-unused-vars
import React, { memo, useEffect, useState } from 'react';
import { bool, string, func } from 'prop-types';
import noop from 'lodash/noop';
import { useContextSelector } from 'use-context-selector';

import WishlistsDropdownComponent from 'Components/Wishlists/WishlistsDropdown';
import { WishlistContext } from 'Contexts/WishlistContext';

const WishlistsDropdown = memo(props => {
  const { onChangeList = noop, id, showSelectedIcon } = props;
  const { wishlists, loadingLists, stockAlertWishlist, defaultWishlist } = useContextSelector(WishlistContext, d => ({
    wishlists: d.data,
    loadingLists: d.isLoading,
    stockAlertWishlist: d.stockAlertWishlist,
    defaultWishlist: d.defaultWishlist
  }));
  const [lists, setLists] = useState(
    [stockAlertWishlist].concat(Object.values(wishlists || {}))
  );
  const [search, setSearch] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [selectedList, setSelectedList] = useState(null);

  useEffect(() => {
    if (id && lists) {
      setSelectedList(prevList => lists.find(list => list?.id === id) || prevList);
    }
  }, [id, lists]);

  useEffect(() => {
    setSearch('');
    setLists([stockAlertWishlist].concat(Object.values(wishlists || {})));
  }, [wishlists, stockAlertWishlist]);

  useEffect(() => {
    if (
      !selectedList
      && defaultWishlist
    ) {
      setSelectedList(defaultWishlist);
    }
  }, [selectedList, defaultWishlist]);

  useEffect(() => {
    if (
      search
      && search.length > 0
    ) {
      // setSelectedList(null);
    }
    if (search?.length >= 2) {
      const re = new RegExp(search.replace(/\/|\\/, ''), 'i');
      setLists(() => [stockAlertWishlist].concat(Object.values(wishlists)).filter(list => re.test(list?.name)));
    } else {
      setLists([stockAlertWishlist].concat(Object.values(wishlists)));
    }
  }, [search, stockAlertWishlist, wishlists]);

  useEffect(() => {
    if (
      selectedList
      && search
      && selectedList.name === search
    ) {
      setSearch('');
    }
  }, [selectedList, search]);

  const setWishlist = ({ selectedItem: selected }) => {
    if (search !== '') {
      setSearch('');
      setLists([stockAlertWishlist].concat(Object.values(wishlists)));
    }
    setIsOpen(false);
    if (
      selected
      && selectedList?.id !== selected.id
    ) {
      setSelectedList(lists.find(list => list?.id === selected.id));
      onChangeList(selected.id);
    }
  };

  const handleOnInputChange = value => {
    setSearch(value);
  };

  const handleOnToggleClick = focused => () => setIsOpen(focused);

  return (
    <WishlistsDropdownComponent
      isOpen={ isOpen }
      lists={ lists }
      selectedItem={ isOpen ? search : selectedList?.id || '' }
      showSelectedIcon={ showSelectedIcon }
      loadingLists={ loadingLists }
      selectedList={ selectedList }
      setWishlist={ setWishlist }
      onInputChange={ handleOnInputChange }
      onToggleClick={ handleOnToggleClick }
    />
  );
});

WishlistsDropdown.propTypes = {
  onChangeList: func,
  id: string,
  showSelectedIcon: bool
};

WishlistsDropdown.displayName = 'WishlistsDropdownContainer';

export default WishlistsDropdown;
